
function applySubscriptionPrice() {
    const priceSource = document.querySelector(".price[bss-b2b-variant-price] .bss-b2b-price-has-vat, .price[bss-b2b-variant-price] .bss-b2b-price-no-vat");
    if (!priceSource) return;

    const priceText = priceSource.textContent.trim(); 
    // £3.29 inc. VAT

    const priceMatch = priceText.match(/([\£\€\$])([\d.]+)/);
    if (!priceMatch) return;

    const currency = priceMatch[1];
    const basePrice = parseFloat(priceMatch[2]);

    const vatSuffix = priceText.replace(/^[\£\€\$\d.\s]+/, "").trim();

    // lấy % discount
    const label = document.querySelector('.payAsYouGoPlansDropdownWrapper label[for^="appstle_selling_plan_label_"]');
    if (!label) return;

    const percentMatch = label.getAttribute("for").match(/(\d+)$/);
    if (!percentMatch) return;

    const discount = parseInt(percentMatch[1], 10);

    const discountedPrice = (basePrice * (1 - discount / 100)).toFixed(2);

    /* ---------- ONE TIME PRICE ---------- */

    const oneTime = document.querySelector(".appstle_one_time_price_wrapper");
    if (oneTime) {
        oneTime.textContent = `${currency}${basePrice.toFixed(2)} ${vatSuffix}`;
    }

    /* ---------- SUBSCRIBE PRICE ---------- */

    const subPrice = document.querySelector(".appstle_subscription_amount.transcy-money");
    if (subPrice) {
        subPrice.textContent = `${currency}${discountedPrice} ${vatSuffix}`;
    }

    /* ---------- COMPARE PRICE ---------- */

    const compare = document.querySelector(".appstle_subscription_compare_amount.transcy-money");
    if (compare) {
        compare.textContent = `${currency}${basePrice.toFixed(2)} ${vatSuffix}`;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
        setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList?.contains('appstle_subscription_amount-appstle-sr-only')) {
                    setTimeout(() => {
                        applySubscriptionPrice();
                    }, 700);
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        }, 300);
    }

    // khi đổi purchase option
    document.addEventListener("change", (e) => {
        if (e.target.closest(".appstle_subscription_wrapper")) {
            setTimeout(() => {
                applySubscriptionPrice();
            }, 200);
        }
    });
});

let counter = 0;
let selector = ".price[bss-b2b-variant-price] .bss-b2b-price-has-vat, .price[bss-b2b-variant-price] .bss-b2b-price-no-vat"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        clearInterval(interval);
        setTimeout(applySubscriptionPrice, 200);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 